module.exports = __webpack_public_path__ + "img/4.6db8f97e.webp";